export default __webpack_public_path__ + "static/media/pictogramShopping64.47d2821d.svg";